const getHashtags = (text)=>{
    return text.split(' ').filter(v=> v.startsWith('#'))
}

export default getHashtags